import i18next from "i18next";
import React from "react";
import { useMapContext } from "../../Contexts/MapContext";
import "./CustomerInfo.scss";

export const CustomerInfo = (): JSX.Element => {
    const { configA } = useMapContext();

    const onHelpIconClick = () =>
        configA.geotelpa?.helpLink && window.open(configA.geotelpa?.helpLink, "_blank").focus();

    return (
        <div className="customer-info">
            <div className="customer-logo-container">
                {configA.geotelpa.logo && <img className="customer-logo-image" src={configA.geotelpa.logo} />}
                {configA.geotelpa.logo2 && <img className="customer-logo-image" src={configA.geotelpa.logo2} />}
                <span
                    title={configA.geotelpa?.helpText ? configA.geotelpa.helpText : ""}
                    onClick={onHelpIconClick}
                    className="esri-icon-question helpIcon map-download-help"
                ></span>
            </div>
            <div className="info-text">{i18next.t("mapDownload.description")}</div>
        </div>
    );
};
